import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';

declare var $: any;

@Component({
  selector: 'ngx-work-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {

  private _pet_no: number;
  metabolic = true;
  dental = true;
  vital = false;
  envment = false;


  @Input() set pet_no(value: number) {
    this._pet_no = value;
    // this.petService.getPetCheckIn(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  ver(tipo: string) {
    this.metabolic = tipo === 'metabolic'
    this.envment = tipo === 'envment'
    this.vital = tipo === 'vital'
    this.dental = tipo === 'dental'
  }
}
